import React, { useState, useEffect } from "react";
import { Container, Button, Dropdown, Spinner, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Styles/yellowcalfcss/Bills.css";
import { FaEdit, FaEye, FaSearch, FaTrashAlt } from "react-icons/fa";
import { simplePostCall } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';
import { toast, ToastContainer } from 'react-toastify';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import ScaleLoader from 'react-spinners/ScaleLoader';
import CustomPagination from '../../components/CustomPagination ';






// --- SVG Components ---
const Eye = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const Edit = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M12 20h9"></path>
    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4 12.5-12.5z"></path>
  </svg>
);

const Trash2 = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"></path>
    <path d="M10 11v6"></path>
    <path d="M14 11v6"></path>
    <path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"></path>
  </svg>
);

const Download = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="7 10 12 15 17 10"></polyline>
    <line x1="12" y1="15" x2="12" y2="3"></line>
  </svg>
);

// --- Main Component ---
export default function BillList() {
  const [bills, setBills] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ billNumber: "", billDate: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [nextPage, setNextPage] = useState(false);
  const [selectedBillIds, setSelectedBillIds] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [id, setId] = useState(null);
  
  const itemsPerPage = 9999;

  // Toggle single checkbox
const handleSelectBill = (billId) => {
  setSelectedBillIds((prev) =>
    prev.includes(billId)
      ? prev.filter((id) => id !== billId)
      : [...prev, billId]
  );
};

// Toggle select all (optional but matches UI image)
const handleSelectAll = (checked) => {
  if (checked) {
    setSelectedBillIds(bills.map((b) => b.bill_id));
  } else {
    setSelectedBillIds([]);
  }
};

  // Toggle select all (optional but matches UI image)

  const handleDeleteBill = async () => {
    setIsDeleting(true);

    const requestBody = {
      customer_id: Number(localStorage.getItem("customer_id")),
      api_key: localStorage.getItem("api_key"),
      user_id: Number(localStorage.getItem("user_id")),
      language: "en",
      id: Number(id),
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billDelete,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        toast.success(response?.message || "Supplier deleted successfully");
        setShowDeleteModal(false);
        fetchBillsList();
      } else {
        toast.error(response?.message || "Failed to delete supplier");
      }
    } catch (error) {
      console.error("Delete supplier error:", error);
      toast.error("Network error occurred");
    } finally {
      setIsDeleting(false);
    }
  };

  // Fetch data on load
  useEffect(() => {
    fetchBillsList();
  }, [currentPage]);

  const fetchBillsList = async () => {
    setLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");
    const user_id = localStorage.getItem("user_id");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      user_id: Number(user_id),
      language: "en",
      limit : itemsPerPage,
      page : currentPage
    };

    try {
      const response = await simplePostCall(
        ApiConfig.billviewList,
        JSON.stringify(requestBody),
      );

      if (response?.result && response?.data) {
        // Data Normalization: Handle mixed types (numbers vs "$ string")
        const normalizedData = response.data.map((item, index) => ({
          id: `${item.bill_number}-${index}`, // Unique key for React
          billNumber: item.bill_number,
          bill_id: item.bill_id,
          supplier: item.supplier_name,
          billDate: item.bill_date,
          dueDate: item.bill_due_date,
          totalAmount:
            typeof item.bill_total_amount === "string"
              ? item.bill_total_amount
              : `$${item.bill_total_amount}`,
          status: item.bill_status.replace("_", " "), // "partial_paid" -> "partial paid"
        }));
        setBills(normalizedData);
setNextPage(response?.next_page)
      }

    } catch (error) {
      console.error("Error fetching bills:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filter Logic
  const filteredBills = bills.filter(
    (bill) =>
      (bill.billNumber || "")
        .toLowerCase()
        .includes(filters.billNumber.toLowerCase()) &&
      (bill.billDate || "").includes(filters.billDate),
  );

  // Pagination Calculations
  const totalItems = filteredBills.length;
  const totalPages2 = Math.ceil(totalItems / itemsPerPage);
  const startItem = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const paginatedBills = filteredBills.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const getPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages2; i++) pageNumbers.push(i);
    return pageNumbers;
  };
  const handleClear = () => {
    setFilters({ billDate: "", billNumber: "" });
    // setMessage("Filters cleared!");
  };

  const handlePayBill = () => {
    if (selectedBillIds?.length < 1) {
      toast.error("Please select a bill");
      return;
    }

    navigate("/accountant/paybill", {
      state: {
        billIds: selectedBillIds,
      },
    });
  };
  return (
    <div className="bill-list-wrapper">
      <ToastContainer position="top-right" autoClose={3000} />
      <Container fluid>
        {/* Header Section */}
        <div className="header-card mt-3">
          <div className="header-content">
            <h4>Purchase Bills</h4>
            <div className="button-group">
              <Button
                className="action-btn"
                onClick={() => navigate("/accountant/CreateBill")}
              >
                Create Bill
              </Button>
              <Button
                className="action-btn"
                onClick={() => navigate("/accountant/PaidBills")}
              >
                Paid Bill
              </Button>
              <Button
                className="action-btn"
                onClick={() => navigate("/accountant/Suppliers")}
              >
                Suppliers
              </Button>
              <Dropdown show={dropdownOpen} onToggle={setDropdownOpen}>
                <Dropdown.Toggle className="action-btn export-btn">
                  <Download /> Export
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item href="#">Export to CSV</Dropdown.Item>
                  <Dropdown.Item href="#">Export to PDF</Dropdown.Item>
                  <Dropdown.Item href="#">Export to Excel</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        {/* Filters Section */}
        <div className="table-top-filters d-flex flex-wrap gap-3">
          <div
            style={{
              position: "relative",
              maxWidth: "200px",
              marginLeft: "-9px",
            }}
          >
            <FaSearch
              style={{
                position: "absolute",
                top: "50%",
                transform: "translateY(-50%)",
                fontSize: "13px",
                color: "#999",
              }}
            />
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Bill Number"
              style={{ paddingLeft: "30px" }}
              value={filters.billNumber}
              onChange={(e) => {
                setFilters({ ...filters, billNumber: e.target.value });
                setCurrentPage(1);
              }}
            />
          </div>

          <div style={{ position: "relative", maxWidth: "200px" }}>
            <input
              type="date"
              className="form-control form-control-sm"
              style={{ paddingLeft: "10px" }}
              value={filters.billDate}
              onChange={(e) => {
                setFilters({ ...filters, billDate: e.target.value });
                setCurrentPage(1);
              }}
            />
          </div>
          <Button
            onClick={handleClear}
            className="upcoming-invoices-clear-button"
          >
            Clear
          </Button>
        </div>

        {/* Table Header */}
        <div
          className="table-header"
          style={{ marginTop: "20px", height: "65px" }}
        >
          <div
            className="table-grid"
            style={{ textAlign: "center", marginLeft: "20px" }}
          >
            {/* <div className="col-checkbox" style={{ fontWeight: 'bold', marginTop: '10px' }}>
  <input
    type="checkbox"
    checked={
      paginatedBills.length > 0 &&
      selectedBillIds.length === paginatedBills.length
    }
    onChange={(e) => handleSelectAll(e.target.checked)}
  />
</div> */}

<div
  className="col-sr"
  style={{
    fontWeight: "bold",
    fontSize: "15px",
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    justifyContent: "center"
  }}
>
  <input
    type="checkbox"
    checked={
      bills?.length > 0 &&
      selectedBillIds?.length === bills.length
    }
    onChange={(e) => handleSelectAll(e.target.checked)}
  />
  Sr No
</div>
             <div className="col-bill" style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Bill Number</div>
            <div className="col-supplier" style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Supplier</div>
            <div className="col-date" style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Bill Date</div>
            <div className="col-date" style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Due Date</div>
            <div className="col-amount" style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Total Amount</div>
            <div className="col-status" style={{ fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Status</div>
            <div className="col-actions" style={{ marginLeft: '35px', fontWeight: 'bold', fontSize: '15px', marginTop: '10px' }}>Actions</div>
          </div>
        </div>

        {/* Table Body */}
        <div className="table-rows">
          {loading ? (
            <div className="text-center p-2"><ScaleLoader color="#F4BB44" /></div>
          ) : bills.length === 0 ? (
            <div className="table-row empty-row">No bills found.</div>
          ) : (
            bills.map((b, index) => (
              <div key={b.id} className="table-row" style={{ height: '45px' }}>
                <div className="table-grid" style={{ textAlign: 'center', marginLeft: '18px', marginTop: '-5px' }}>
                  {/* <div className="col-sr" style={{ fontSize: '14px' }}>{startItem + index}</div> */}
                  <div
                    className="col-sr"
                    style={{
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      justifyContent: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedBillIds?.includes(b.bill_id)}
                      onChange={() => handleSelectBill(b.bill_id)}
                    />
                    <span>{startItem + index}</span>
                  </div>
                  <div className="col-bill" style={{ fontSize: "14px" }}>
                    {b.billNumber}
                  </div>
                  <div className="col-supplier" style={{ fontSize: "14px" }}>
                    {b.supplier}
                  </div>
                  <div className="col-date" style={{ fontSize: "14px" }}>
                    {b.billDate}
                  </div>
                  <div className="col-date" style={{ fontSize: "14px" }}>
                    {b.dueDate}
                  </div>
                  <div className="col-amount" style={{ fontSize: "14px" }}>
                    {b.totalAmount}
                  </div>
                  <div
                    className="col-status"
                    style={{ fontSize: "14px", textTransform: "capitalize" }}
                  >
                    {b.status}
                  </div>
                  <div
                    className="col-actions"
                    style={{ gap: "0px", marginLeft: "20px" }}
                  >
                    <Button
                      className="icon-btn"
                      onClick={() =>
                        navigate(`/accountant/ViewBill/${b.bill_id}`)
                      }
                      title="View"
                    >
                      <Eye />
                    </Button>
                    <Button
                      className="icon-btn"
                      onClick={() =>
                        navigate(`/accountant/createbill/${b.bill_id}`)
                      }
                      title="Edit"
                    >
                      <Edit />
                    </Button>
                    <Button
                      className="icon-btn"
                      onClick={() => {
                        setId(b.bill_id);
                        setShowDeleteModal(true);
                      }}
                      title="Delete"
                    >
                      <Trash2 />
                    </Button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Pagination */}
        <div className='mt-2 d-flex justify-content-end'>
     {/* <CustomPagination
  currentPage={currentPage}
  nextPage={nextPage}
  onPageChange={(page) => setCurrentPage(page)}
/> */}
</div>
        <div className='d-flex justify-content-end'> 
            <Button className="button-finance-option" onClick={handlePayBill}>Pay Bill</Button>
     </div>
        {/* {!loading && totalItems > 0 && (
          <div className="pagination-card mt-0" >
            <div className="pagination-info">Showing {startItem} to {endItem} of {totalItems} entries</div>
            <div className="pagination-controls">
              {getPageNumbers().map((number) => (
                <Button
                  key={number}
                  className={
                    currentPage === number ? "page-btn active" : "page-btn"
                  }
                  onClick={() => setCurrentPage(number)}
                >
                  {number}
                </Button>
              ))}
            </div>
          </div>
        )} */}
      </Container>
      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        title="Delete Bill"
        message="Are you sure you want to delete this bill?"
        confirmText="Delete"
        confirmVariant="danger"
        onConfirm={handleDeleteBill}
        isLoading={isDeleting}
      />
    </div>
  );
}
